import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { SITE } from "@/data/site";
import Logo from "./Logo";
import SocialLinks from "./SocialLinks";
import { COMPLIANCE } from "@/data/site";

export const Footer = () => {
  const [year, setYear] = useState(2026);
  useEffect(() => setYear(new Date().getFullYear()), []);

  const big =
    "font-display text-3xl sm:text-4xl md:text-5xl leading-tight text-[#f2f5f4]/90 transition-colors duration-300 hover:text-[#0e8c8c]";

  return (
    <footer className="grain lab-grid-dark relative overflow-hidden bg-[#070b0c] text-white" data-testid="site-footer">
      <div className="relative z-10 mx-auto max-w-[1440px] px-5 py-20 md:px-10 md:py-24">
        <div className="flex flex-col justify-between gap-14 md:flex-row">
          <div className="max-w-sm">
            <Logo dark />
            <p className="mt-6 text-sm leading-relaxed text-white/60">
              {SITE.tagline} Advanced cosmetic formulas supporting healthy-looking skin and hair through clinical
              exosome science.
            </p>
            <SocialLinks dark className="mt-8" />
          </div>
          <nav className="flex flex-col items-start gap-3" data-testid="footer-links">
            <span className="font-lab mb-2 text-[10px] uppercase tracking-[0.2em] text-white/40">Navigate</span>
            <Link to="/" className={big}>Collection</Link>
            <Link to="/team" className={big} data-testid="footer-team-link">Meet the Team</Link>
            <Link to="/certification" className={big} data-testid="footer-certification-link">Certification</Link>
            <Link to="/education" className={big} data-testid="footer-education-link">Research Education</Link>
            <Link to="/whitepaper" className={big} data-testid="footer-whitepaper-link">White Paper</Link>
            <Link to="/crm" className={`${big} text-[#f2f5f4]/60`} data-testid="footer-portal-link">CRM Portal</Link>
            <Link to="/careers" className={big} data-testid="footer-careers-link">Join Our Team</Link>
            <Link to="/admin" className={`${big} text-[#f2f5f4]/60`} data-testid="footer-admin-link">Admin</Link>
            <a href="mailto:info@exoplusbio.com" className={big} data-testid="footer-contact-link">Contact</a>
          </nav>
        </div>

        <div className="mt-20 border-t border-white/10 pt-8">
          <p className="max-w-4xl text-[11px] leading-relaxed text-white/40" data-testid="footer-compliance">
            {COMPLIANCE}
          </p>
          <div className="font-lab mt-6 flex flex-col gap-2 text-[10px] uppercase tracking-[0.16em] text-white/35 sm:flex-row sm:items-center sm:justify-between">
            <span>© {year} Exoplus Bio — All rights reserved</span>
            <span>Cosmetic use only · Not a drug</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
